define.alias("ember-cli-string-helpers/helpers/classify", "settings/helpers/classify");